import { useContext, useEffect, useState } from "react"
import { SessionContext } from "src/contexts/SessionContext"
import { IBubble } from "src/components/Bubble/types"
import { useMutation } from "@tanstack/react-query"
import { FormikValues } from "formik"
import { ChatSideEnum } from "src/types"
import { apiProvider } from "src/api"
import { TimerContext } from "src/contexts/TimerContext"

export const useSessionContext = () => {
    return useContext(SessionContext)
}

export const useTimerContext = () => {
    return useContext(TimerContext)
}

export const useGetCarouselConfig = () => {
    const [slidesPerView, setSlidesPerView] = useState<number>(1)

    useEffect(() => {
        const callback = () => {
            setSlidesPerView(window.innerWidth < 1280 ? 1.2 : 1)
        }

        window.addEventListener("resize", callback)

        return () => {
            window.removeEventListener("resize", callback)
        }
    }, [])

    return {
        slidesPerView
    }
}

export const useChat = () => {
    const [messages, setMessages] = useState<IBubble[]>([])
    const { currentCompany, prompts, currentRound } = useSessionContext()
    const [isCorrectAnswer, setIsCorrectAnswer] = useState<boolean>(false)
    const [threadId, setThreadId] = useState<string>("")

    const { mutate: sendMessage, isPending } = useMutation({
        mutationFn: async (variables: { values: FormikValues }) => {
            try {
                // Пропускаем первое сообщение
                if (messages.length) {
                    setMessages((prev) => {
                        const newMessage = {
                            side: ChatSideEnum.USER,
                            text: variables.values.message,
                            time: new Date()
                        }
                        return [
                            ...prev,
                            newMessage
                        ]
                    })
                }
                const response = await apiProvider.post(`?chat=${currentCompany}&id=${prompts[currentRound]}${threadId ? `&threadId=${threadId}` : ""}`, {
                    message: variables.values.message,
                })

                // Монтируем ответ
                setMessages((prev) => {
                    const newMessage = {
                        side: ChatSideEnum.AI,
                        text: response.data.output,
                        time: new Date()
                    }
                    return [
                        ...prev,
                        newMessage
                    ]
                })

                // Установка threadId, для последующих сообщений
                setThreadId(response.data.threadId)

                // Проверяем, пройден ли раунд
                if (response.data.isSuccess) {
                    setIsCorrectAnswer(true)
                }
            } catch (error) {
                console.error(error)
            }
        },
        retry: false
    })

    useEffect(() => {
        if (currentCompany && !messages.length && !isPending) {
            sendMessage({
                values: {
                    message: "Начали"
                }
            })
        }
    }, [currentCompany, messages, isPending])

    return {
        messages,
        sendMessage,
        isPending,
        isCorrectAnswer
    }
}